"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Divider = exports.Container = void 0;
const material_1 = require("@mui/material");
const Divider_1 = __importDefault(require("@mui/material/Divider"));
exports.Container = (0, material_1.styled)("div")(({ theme }) => ({
    flex: 1,
    height: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    borderRadius: 2,
    boxShadow: "0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)",
    backgroundColor: "#FFF",
    [theme.breakpoints.down("sm")]: {
        paddingBottom: theme.spacing(1),
        flexDirection: "column",
        alignItems: "baseline",
    },
}));
exports.Divider = (0, material_1.styled)(Divider_1.default)(({ theme }) => ({
    height: "80%",
    backgroundColor: "#0000",
    borderLeftColor: theme.palette.grey[300],
    borderLeftWidth: 1,
    borderRight: "none",
    borderLeftStyle: "dashed",
    [theme.breakpoints.down("sm")]: {
        display: "none",
    },
}));
